<template>
    <div class="resumeOther">
        <el-row>
            <el-col :span="4" class="resumeItem">
                <h1>竞赛经历</h1>
            </el-col>
            <el-col :span="20">
                <div class="resumeContent" v-for="(item,index) in resumeInfo.competitionExperienceList">
                    <el-row>
                        <el-col :span="12">
                            <p><b>{{item.name}}</b></p>
                        </el-col>
                        <el-col :span="12">
                            <p>{{item.level}}</p>
                        </el-col>
                    </el-row>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    export default {
        name: 'CompetitionExperience',
        props: ['resumeInfo'],
        data(){
            return {
                // 表单编辑状态
                editStatus: {
                    id: 0,
                    status: false,
                },
                form: {
                    type: '泰迪杯',
                },
            }
        },
        computed: {
            // 简历竞赛经历列表数量
            competitionExperienceSize(){
                return this.size();
            }
        },
        created() {
        },
        methods: {
            // 计算简历竞赛经历数量
            size(){
                var competitionExperienceSize = 0;
                for(var i in this.resumeInfo.competitionExperienceList) {
                    competitionExperienceSize++;
                }
                return competitionExperienceSize;
            },
        },
    }
</script>